import { Box, Container, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import { TitleH2Bold } from '../../theme/typography'
import PropTypes from 'proptypes'
import styled, { createGlobalStyle, keyframes } from 'styled-components'
import BlueBorderBox from './BlueBorderBox'
import ItemCard from '../Other/ItemCard'

const GlobalStyles = createGlobalStyle`
  html {
    --cards-carousel-width: 2000px
  }
`
const moveLeft = keyframes`
  from {
    transform: translateX(0px);
  }
  to {
    transform: translateX(-2000px);
    transform: translateX(calc(var(--cards-carousel-width) * -1))
  }
`

const CarouselWrap = styled(Box)`
  --cards-carousel-width: 2000px;
  width: 100%;
  display: flex;
  transform: translate3d(0, 0, 0);
  width: var(--cards-carousel-width);
  padding-bottom: 16px;
  &:hover {
    animation-play-state: paused;
  }
  @media (min-width: 960px) {
    overflow: visible;
    animation: 30s linear 0s infinite normal none ${moveLeft};
  }
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: -2px;
  webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #c6ccce #f3f6f6;

  &::-webkit-scrollbar-track {
    box-shadow: inset 1px 1px 2px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    background-color: transparent;
  }

  &::-webkit-scrollbar {
    width: 4px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #c6ccce;
  }

  &::-webkit-scrollbar {
    height: 3px;
  }
`
const ContainerWrap = styled(Container)(({ theme, bgcolor }) => ({
  padding: theme.spacing(6, 2),
  color: bgcolor === 'dark' ? theme.colors.white : theme.colors.blue5,
  '& p': {
    color: bgcolor === 'dark' ? theme.colors.white : theme.colors.colorTransparent6
  }
}))
const TitleH2BoldStyled = styled(TitleH2Bold)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    fontSize: '2.0625rem'
  }
}))
const BoxWrap = styled(Box)(({ theme, bgcolor }) => ({
  position: 'relative',
  zIndex: 2,
  backgroundColor: bgcolor === 'white' ? theme.colors.grey1 : 'transparent',
  paddingBottom: theme.spacing(4)
}))

function ItemCarousel(props) {
  useEffect(() => {
    var infiniteCarousel = document.querySelector('.cards-infinite-carousel')
    if (infiniteCarousel) {
      var carouselWidth =
        (infiniteCarousel.childElementCount * (infiniteCarousel.children[0].offsetWidth + 48)) / 2
      document.documentElement.style.setProperty('--cards-carousel-width', carouselWidth + 'px')
      document.documentElement.style.setProperty('--carousel-width-minus', -carouselWidth + 'px')
    }
  }, [])

  const cardsArray = []
  while (cardsArray.length < 12) {
    props.list && props.list.forEach((item) => cardsArray.push(item))
  }

  return (
    <BoxWrap bgcolor={props.bgcolor} align="center" style={{ overflow: 'hidden' }}>
      {props.title && (
        <ContainerWrap bgcolor={props.bgcolor} maxWidth="md" pb={6}>
          <TitleH2BoldStyled component="h2" gutterBottom>
            {props.title}
          </TitleH2BoldStyled>
          <Typography component="div" dangerouslySetInnerHTML={{ __html: props.content }} />
        </ContainerWrap>
      )}

      <GlobalStyles />
      <CarouselWrap className="cards-infinite-carousel">
        {cardsArray.length &&
          cardsArray.map((item, i) => {
            return props.type === 'bluebox' ? (
              <BlueBorderBox key={`bluebox-item${i}`} {...item} />
            ) : (
              <ItemCard key={`white-item${i}`} {...item} alignLeft large />
            )
          })}
      </CarouselWrap>
    </BoxWrap>
  )
}

export default ItemCarousel

ItemCarousel.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string,
      image: PropTypes.string,
      imageAlt: PropTypes.string
    })
  )
}
